<template>
  <div class="fill-height d-flex flex-column white">
    <AppBar
      color="primary"
      dark
      disable-help
      disable-lang
      :disable-menu="false"
    />
    <header style="background-color: #e5e3ff;" class="header-page">
      <v-container style="padding-bottom:0px;">
        <section style="display: block;">
          <p
            class="text-center font-weight-medium"
            v-html="$t('global.traveler.welcome')"
            style="line-height: 1.2rem !important; display: block;margin-bottom: unset;font-size: 15px;"
          >
          </p>
        </section>
        <section style="display: block;">
          <div class="text-center">
          <v-btn
            class="font-weight-bold mx-1 px-1"
            text
            color="primary"
            @click="dialog.arrival = !dialog.arrival"
            >{{ $t("global.btnArrival") }}</v-btn
          >
        </div>
        </section>
      </v-container>
    </header>

   
    <div class="fill-height">
        <v-container>
          <section v-show="moduleActive==='rides'" style="margin-bottom: 100px;">
            <v-col cols="12">
              <LayoutBase :title="t('traveler.modMyRides').toUpperCase()">
                <template #titleIcon>
                  <v-icon class="primary--text">directions_car</v-icon>
                </template>
              </LayoutBase>
            </v-col>
            <v-row
            dense
            class="my-7"
            v-if="reservationModel.additionalServices.length > 0"
          >
          
            <v-col cols="12">
              <LayoutBase
                text-color="black--text"
                color="secondary"
                :title="t('traveler.additional-services.title').toUpperCase()"
              >
                <LayoutCard
                  class="mb-2"
                  v-for="(additional, i) of reservationModel.additionalServices"
                  :key="i"
                  icon="hail"
                  :title="additional.additionalServiceType.name"
                >
                  <template v-slot:icon>
                    <v-container class="ma-0" style="width: 50px">
                      <v-img
                        max-height="auto"
                        max-width="45px"
                        width="100%"
                        :src="getIcon(additional.additionalServiceType.code)"
                      ></v-img>
                    </v-container>
                  </template>
                  <div class="d-flex justify-space-between">
                    <span>{{
                      t(
                        `traveler.additional-services.description.${additional.additionalServiceType.rateType}.subtitle`,
                        { cant: sumQuantity(additional) }
                      )
                    }}</span>
                    <span class="subtitle-2 font-weight-bold"
                      >{{ additional.bookingCurrency.toUpperCase() }} ${{
                        additional.bookingPriceTotal
                      }}</span
                    >
                  </div>
                </LayoutCard>
              </LayoutBase>
              <v-img class="mt-7" src="~@/assets/lines.svg"></v-img>
            </v-col>
            </v-row>
            <div>
              <TransportServices
                v-for="(service, i) in transportServices"
                :key="i"
                :service="service"
                :darkStyle="darkStyle(i)"
              />
            </div>
          </section>
 
          <!----<v-img class="mt-7" src="~@/assets/lines.svg"></v-img>--->
          <section v-show="moduleActive==='contact'"  style="margin-bottom: 100px;">
            <v-col cols="12">
                  <LayoutBase :title="t('contact.header').toUpperCase()">
                    <template #titleIcon>
                      <v-icon class="primary--text">account_circle</v-icon>
                    </template>
                  </LayoutBase>
                </v-col>
            <v-form ref="form" id="tab-1">
              <v-row dense class="my-2">
                
                <v-col cols="12" class="mt-5">
                  <TextField
                    :rules="emailRules"
                    v-model="formContact.email"
                    :title="`${t('contact.email')}*`"
                  />
                </v-col>
                <v-col cols="12">
                  <PhoneField
                    v-if="copied"
                    ref="phoneField"
                    v-model="formContact.phone"
                    :messages="t('contact.phoneMessage')"
                    :title="`${t('contact.phone')}*`"
                  />
                </v-col>
              </v-row>
            </v-form>
             <!-- Alert for incomplete contact info -->
             <v-alert
                v-if="infoConfirmedByClient == 0"
                type="warning"
                color="#fff3cd"
                border="left"
                elevation="1"
                class="mb-4"
                style="text-align: center;"
                
              >
                <template v-slot:prepend>
                  <v-icon color="#856404" small>mdi-alert</v-icon>
                </template>
                <p  v-html="$t('section.tracking.contactInfoAlert')" class="text-body-2" style="color: #856404;"></p>
              </v-alert>

            <v-card height="88px" class="mt-1" elevation="7">
              <v-container class="d-flex align-center fill-height">
                <v-btn block rounded outlined color="primary" @click="save">{{
                  $t("global.btnSaveContacto")
                }}</v-btn>
              </v-container>
            </v-card>
            <div class="d-md-none">
              <GordianBanner
                step="check-in"
                display-type="default-banner"
              />
            </div>
            <div class="gordian-siderbar d-md-block">
              <GordianBanner
                step="check-in"
                display-type="vertical-banner"
              />
            </div>
          </section >

          <section v-show="moduleActive==='add'"  style="margin-bottom: 100px;">
            <v-col cols="12">
              <LayoutBase :title="t('traveler.modAdditionalServices').toUpperCase()">
                <template #titleIcon>
                    <v-icon class="primary--text">shopping_cart</v-icon>
                </template>
              </LayoutBase>
            </v-col>
            <v-row v-if="moduleActive==='add'">
              <v-col>
                <ProductList />
              </v-col>
            </v-row>
          </section>
        </v-container>
        
        <section class="footer" v-if="reservationModel.id>0">
        
          <v-card>
            <v-tabs
              v-model="tabIndex"
              background-color="deep-purple accent-2"
              centered
              dark
              icons-and-text
              style="position: fixed; bottom: 0; left: 0; width: 100%;z-index:999 "
            >
       
            
              
              
              <v-tab @click="clickedNav('contact')" class="text-capitalize text-caption btn-menu"  :active="currentModule === 'contact'">
                <span v-if="false">{{ $t("section.tracking.personalHub") }}</span>
                <span>
                  <v-icon>account_circle</v-icon> 
                   <!-- Badge indicating incomplete info -->
                  <v-icon
                      class="__shake"
                      
                      v-if="infoConfirmedByClient == 0"
                      color="warning"
                      style="margin-top: -10px;font-size: 18px;"
                    >
                    report_problem
                    </v-icon>
                   
                </span>
                  
              </v-tab>
              <v-tab  @click="clickedNav('rides')" class="text-capitalize text-caption btn-menu "  :active="currentModule === 'rides'" >
               <span v-if="false">{{ $t("section.tracking.journeyHub") }} ({{ transportServices.length }}) </span>
                <v-icon>directions_car</v-icon>
              </v-tab>
              <v-tab  @click="clickedNav('add')" class="text-capitalize text-caption btn-menu "  :active="currentModule === 'add'" >
               <span v-if="false">{{ $t("section.tracking.journeyHub") }} ({{ transportServices.length }}) </span>
                <v-icon>shopping_cart</v-icon>
              </v-tab>
            </v-tabs>
          </v-card>
        </section>
    </div>
    <DialogArrival v-model="dialog.arrival" />
  </div>
</template>

<script>
import AppBar from "@/components/AppBar";
import DialogArrival from "@/components/dialog/DialogArrival";
import GordianBanner from "@/components/GordianBanner";
import LayoutBase from "@/layouts/LayoutBase";
import LayoutCard from "@/layouts/LayoutCard";
import TextField from "@/components/field/TextField";
import PhoneField from "@/components/field/PhoneField";
import { getIcon } from "@/helpers/market";
import ProductList from "@/components/market/ProductList";
import TransportServices from "./TransportServices";
import { api } from "@/service/api.service";
import { mapActions, mapState,mapMutations } from "vuex";
export default {
  components: {
    AppBar,
    ProductList,
    DialogArrival,
    LayoutCard,
    LayoutBase,
    TextField,
    PhoneField,
    TransportServices,
    GordianBanner
  },
  data: vm => ({
    emailRules: [
      v => !!v || vm.$t("global.required"),
      v =>
        !v ||
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
        vm.$t("global.emailValid")
    ],
    dialog: {
      info: false,
      arrival: false,
      covid: false
    },
    formContact: {
      phone: null,
      email: null
    },
    copied: false,
    destinationAirportIata:null,
    originAirportIata:null,
    tabIndex:1
  }),
  created() {
    this.setContactData();
  },
  async mounted() {
    await this._fetchReservation();
    this._initIntercom();
    if(this.infoConfirmedByClient==0){
      this.clickedNav("contact");
    }
   
      
    //this._hideIntercomLauncher();
    //this._initGrx();
  },
  watch: {
    reservationId() {
      this.setContactData();
    }
  },
  computed: {
    ...mapState("reservation", ["reservationModel"]),
    ...mapState('lang',['lang']),
    ...mapState('global',['currentModule']),
    reservationId: vm => vm.reservationModel.id,
    transportServices: vm => vm.reservationModel?.transportServices || [],
    isIataCun: vm => {
      let aux = false
      vm.transportServices.forEach(({dropoff, pickup}) => {
        if(dropoff.iata === 'CUN') {
          aux = true
        } else if (pickup.iata === 'CUN') {
          aux = true
        }
      })
      return aux
    },
    moduleActive(){
      return this.currentModule
    },
    infoConfirmedByClient(){
      return this.reservationModel.client.infoConfirmedByClient
    },
  },
  methods: {
    ...mapActions("service", ["_openCheckin"]),
    ...mapActions("reservation", ["_fetchReservation"]),
    ...mapActions("global", ["_initIntercom"]),
    ...mapMutations("global",["SET_CURRENT_MODULE"]),
    ...mapMutations("global",["SET_CURRENT_MODULE"]),
    loadAirportIatas(){
      if (this.transportServices.length>0) {
        try{
          let {pickup, dropoff, flightValidationData} = this.transportServices[0]

          if (dropoff.isAirport) { //salida, es decir, vuelo origen es el iata del aeropuerto
            this.originAirportIata = dropoff.iata
            if (flightValidationData != null) {
              this.destinationAirportIata = flightValidationData.arrival.airportIata
            }
          }else{
            this.destinationAirportIata = pickup.iata
            if (flightValidationData != null) {
              this.originAirportIata = flightValidationData.departure.airportIata
            }
          }
      }catch(err){
        console.log(err);
      }

      }
    },
    _initGrx(){
      this.loadAirportIatas()
      window.Grx.setContext({
        env: "prod",
        lang: this.lang == 'es' ? 'es-mx' : 'en-us',
        currency: this.lang == 'es' ? 'mxn' : 'usd',
        publishable_key: "pk_cDcPr20LoO0EXwcq", // necesario para la producción
      });
      window.Grx.set({
        passengerCount: this.reservationModel.adults + this.reservationModel.children,
        childCount: this.reservationModel.children,
        adultCount: this.reservationModel.adults,
        originAirport: this.originAirportIata,
        destinationAirport: this.destinationAirportIata,
        // airline: 'EE'
      })
    },
    darkStyle(index) {
      if (index % 2 === 0) return false;
      return true;
    },
    getIcon(code) {
      return getIcon(code, true);
    },
    sumQuantity(additional) {
      if (additional.rateType === "person") {
        const { children, adults, infants } = additional;
        return children + adults + infants;
      } else {
        return additional.quantity;
      }
    },
    setContactData() {
      this.copied = false;
      this.formContact.email = this.reservationModel?.client?.email;
      this.formContact.phone = this.reservationModel?.client?.phone;
      setTimeout(() => (this.copied = true), 500);
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      await api
        .patch("/travelers/clients/" + this.reservationModel.client.id, {
          data: { ...this.formContact }
        })
        .then(async() =>
          {
            this.$root.show({
              type: "success",
              title: this.$t("global.message.dataSaved"),
              description: this.$t("global.message.saved")
            })
            await this._fetchReservation();
          }
        )
        .catch(e => console.log(e));
    },
    t(key, options = {}) {
      return this.$t(`section.${key}`, options);
    },
    clickedNav(mod){
      this.SET_CURRENT_MODULE(mod);
      const _tabs = {contact:0,rides:1,add:2};
      this.tabIndex = _tabs[mod]??1;
      //this.moduleActive = mod;
    }
  }
};
</script>
<style>
  .gordian-siderbar {
    position: absolute;
    left: 103%;
    top: 0;
    width: 300px;
    display: none;
  }

</style>
<style lang="scss" scoped>
.img-banner-promotion {
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}


</style>
<style scoped>
.__shake {
  display: inline-block;
  animation: wiggle 2s ease-in-out infinite;
  /*transform-origin: center;*/

}
@keyframes wiggle {
  0% { transform: rotateZ(0deg); }
  15% { transform: rotateZ(-20deg); }
  30% { transform: rotateZ(15deg); }
  45% { transform: rotateZ(-12deg); }
  60% { transform: rotateZ(8deg); }
  75% { transform: rotateZ(-5deg); }
  100% { transform: rotateZ(0deg); }
}
.btn-menu{
  width: 15% !important;
  /*margin:30rem !important;*/
}
.btn-menu .v-icon {
  font-size: 35px !important;
}

div.ride-resume:not(:first-child) {
  margin-top: 30px !important; /* or whatever value you need */
}
</style>

